import React, { Component } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { HeadlineNumber } from '../../../components/UI/HeadlineNumber';

export class ReturnProfitPanel extends Component {
    render() {

        return (
            <Card className="panel-card" data-testid="returnProfitPanel">
                <CardBody>
                    <Row>
                        <Col xs="6">
                            <HeadlineNumber
                                title="ROI"
                                value={this.props.roi + '%'}
                                description='Net profit &divide; purchase costs'
                            />
                        </Col>
                        <Col xs="6">
                            <HeadlineNumber
                                title="Net profit per year"
                                valuePounds={this.props.incomeNet}
                                value={!this.props.incomeNet > 0 && '£0'}
                                description='Gross profit - mortgage'
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="6">
                            <HeadlineNumber
                                title="Earnings after tax"
                                valuePounds={this.props.over150k ? '' : this.props.taxProjectionSPV.netProfitReturned}
                                value={this.props.over150k ? "n/a" : ""}
                                description='Per year, company held'
                            />
                        </Col>
                        <Col xs="6">
                            <HeadlineNumber
                                title="Earnings after tax"
                                valuePounds={this.props.over150k ? '' : this.props.taxProjectionPersonal.netProfitReturned}
                                value={this.props.over150k ? "n/a" : ""}
                                description='Per year, personally held'
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/Components/ReturnProfitPanel.jsx